import React, { useEffect } from 'react';
import { useNavigate, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserRoles } from 'src/latest/src/constants';
import { practiceAdminRoutes } from 'src/latest/src/routes';
import './PracticeAdmin.scss';

export const PracticeAdmin: React.FC = () => {
  const navigate = useNavigate();
  const { loggedInUser } = useSelector((state: any) => state.authentication);

  useEffect(() => {
    const role = loggedInUser?.userRole?.toUpperCase();

    // this code is used to redirect users based on their roles if they try to access the practice admin dashboard directly
    switch (role) {
      case UserRoles.TENANT_SUPER_ADMIN:
        navigate('/super-admin/home', { replace: true });
        break;

      case UserRoles.CLIENT:
        navigate('/therapy/client', { replace: true });
        break;

      case UserRoles.THERAPIST:
        navigate('/therapy/therapist', { replace: true });
        break;

      case UserRoles.PRACTICE_ADMIN:
        break;

      case UserRoles.SCHEDULER:
        navigate('/therapy/scheduler', { replace: true });
        break;

      case UserRoles.BILLING:
        navigate('/billing-admin/home', {replace:true});
        break;

      default:
        navigate('/', { replace: true });
        break;
    }
  }, [loggedInUser, navigate]);

  return (
    <div className="practice-admin-dashboard">
      <Routes>
        <Route index={true} element={<Navigate to="users" replace={true} />} />

        {practiceAdminRoutes?.map(route => (
          <Route
            path={route.path}
            element={
              <div className="practice-admin-dashboard-content-container">
                <route.component />
              </div>
            }
            key={route.path}
          />
        ))}
      </Routes>
    </div>
  );
};